<header class="app-header">
  <button
    class="filter-toggle"
    click.trigger="calendar.toggleFilterPanel()"
    aria-label="Filters"
    aria-haspopup="true"
    aria-expanded.bind="calendar.filterPanelOpen">
    <span class="filter-toggle__icon icon icon--filter" aria-hidden="true"></span>
  </button>
  <h1><span class="icon icon--toy" aria-hidden="true"></span> Toy Calendar</h1>
  <div class="header-actions">
    <account-menu></account-menu>
    <admin-menu></admin-menu>
  </div>
</header>
